const components = {
    "frontend": {
        "home": () => import('./../pages/home/index'),
    },
};

export default components;
